import { MapPin } from 'lucide-react'

type JobLocationPulseMarkerProps = {
  label?: string
  compact?: boolean
  address?: string
}

export function JobLocationPulseMarker({ label, compact = false, address }: JobLocationPulseMarkerProps) {
  const sizeClass = compact ? 'h-10 w-10' : 'h-14 w-14'
  const hasTooltip = Boolean(label && address)

  return (
    <div
      className={`group relative flex flex-col items-center ${hasTooltip ? 'pointer-events-auto' : 'pointer-events-none'}`}
      aria-hidden={!label}
      aria-label={label ? `Job location: ${label}` : 'Job location'}
    >
      {hasTooltip ? (
        <div className="pointer-events-none absolute bottom-full left-1/2 z-30 mb-2 w-max max-w-[240px] -translate-x-1/2 rounded-lg border border-border/60 bg-white px-3 py-2 text-left opacity-0 shadow-lg transition-opacity duration-150 group-hover:opacity-100">
          <p className="text-[12px] font-semibold leading-tight text-foreground">{label}</p>
          {address ? (
            <p className="mt-0.5 text-[11px] leading-tight text-muted-foreground">{address}</p>
          ) : null}
          <div className="absolute left-1/2 top-full h-2 w-2 -translate-x-1/2 -translate-y-1 rotate-45 border-b border-r border-border/60 bg-white" />
        </div>
      ) : null}
      <div className={`relative flex ${sizeClass} items-center justify-center`}>
        <span className="job-location-pulse-ring job-location-pulse-ring--outer absolute inset-0 rounded-full bg-rose-500/25" />
        <span className="job-location-pulse-ring job-location-pulse-ring--inner absolute inset-1 rounded-full bg-rose-500/35" />
        <span className="job-location-pulse-core relative flex h-8 w-8 items-center justify-center rounded-full border-[3px] border-white bg-rose-500 text-white shadow-[0_8px_24px_rgba(244,63,94,0.45)]">
          <MapPin className="h-4 w-4 fill-current" strokeWidth={2.2} />
        </span>
      </div>
      {label ? (
        <div className="mt-1 max-w-[160px] rounded-full border border-white/90 bg-rose-600 px-2.5 py-0.5 text-center text-[10px] font-bold text-white shadow-md">
          <span className="line-clamp-1">{label}</span>
        </div>
      ) : null}
    </div>
  )
}
